<div class="statistics-table-container">
  <div class="table-header">
    <h2>
      <span class="header-spacer"></span>
      <span class="header-title">
        @if (isSummaryTable) {
          {{ isKumMode ? 'KÜM' : 'CC' }} - Összesen ( {{ month }} )
        } @else {
          {{ isKumMode ? 'KÜM' : 'CC' }}: {{ colleagueName }} ( {{ month }} )
        }
      </span>
      <span class="header-end">
        @if (!isSummaryTable) {
          <button mat-icon-button
                  class="history-btn"
                  (click)="openHistoryDialog($event)"
                  matTooltip="Módosítási napló megtekintése">
            <mat-icon>history</mat-icon>
          </button>
        }
        @if (!isSummaryTable && canEditPlan && otherColleagues.length > 0) {
          <button mat-icon-button
                  class="copy-plan-btn"
                  [matMenuTriggerFor]="copyPlanMenu"
                  (click)="$event.stopPropagation()"
                  matTooltip="Tervszámok másolása másik kollégától">
            <mat-icon>content_copy</mat-icon>
          </button>
          <mat-menu #copyPlanMenu="matMenu">
            @for (c of otherColleagues; track c.id) {
              <button mat-menu-item
                      (click)="copyPlanRequested.emit({ sourceUserId: c.id, sourceUsername: c.username })">
                {{ c.username }} tervszámok másolása ide
              </button>
            }
          </mat-menu>
        }
      </span>
    </h2>
  </div>
  
  <div class="table-wrapper">
    <table class="statistics-table">
      <!-- Oszlopszélességek explicit meghatározása -->
      <colgroup>
        <col style="width: 100px;"> <!-- Metrika név oszlop -->
        @for (day of dayNumbers; track $index; let i = $index) {
          <col [style.width]="isWeekend(i) ? '15px' : '35px'">
        }
        <col style="width: 80px;"> <!-- Összesen oszlop -->
      </colgroup>
      <thead>
        <!-- Week numbers row -->
        <tr class="week-numbers-row">
          <th class="metric-name-header">Hét száma</th>
          @for (weekGroup of weekGroups; track $index) {
            <th [attr.colspan]="weekGroup.colspan"
                [class]="'header-week ' + (weekGroup.isWeekend ? 'weekend-header' : '')">
              {{ weekGroup.weekNumber }}
            </th>
          }
          <th class="total-header"></th>
        </tr>
        <!-- Day numbers row -->
        <tr>
          <th class="metric-name-header">Nap</th>
          @for (day of dayNumbers; track $index; let i = $index) {
            <th [class]="'header-day ' + (isWeekend(i) ? 'weekend-header' : '')">
              {{ day }}
            </th>
          }
          <th class="total-header">Összesen</th>
        </tr>
      </thead>
      <tbody>
        @for (metric of metrics; track $index; let metricIndex = $index) {
          <!-- Plan row -->
          <tr class="plan-row">
            <td class="metric-name plan-label">{{ metric.name }} P</td>
            @for (value of metric.planValues; track $index; let i = $index) {
              <td [class]="getCellClassWithNote('plan', i, value) + (!isSummaryTable && canEditPlan && isCellEditableForDay(metricIndex, 'plan', i) ? ' editable-cell' : '')"
                  (dblclick)="!isSummaryTable && canEditPlan && isCellEditableForDay(metricIndex, 'plan', i) ? onRowDoubleClick(metricIndex, 'plan', i) : null"
                  (click)="$event.stopPropagation()">
                @if (!isEditing(metricIndex, 'plan', i)) {
                  {{ formatValue(value, i) }}
                }
                @if (!isSummaryTable && isEditing(metricIndex, 'plan', i)) {
                  <input type="number"
                         [ngModel]="getEditingValue(metricIndex, i)"
                         (ngModelChange)="updateEditingValue(metricIndex, i, $event)"
                         class="edit-input"
                         (keyup.enter)="saveEditing()"
                         (keyup.escape)="cancelEditing()"
                         (click)="$event.stopPropagation()">
                }
              </td>
            }
            <td class="total-cell plan-total">
              {{ getPlanSum(metric) }}
            </td>
          </tr>
          
          <!-- Actual row -->
          <tr class="actual-row">
            <td class="metric-name actual-label">{{ metric.name }} A</td>
            @for (value of metric.actualValues; track $index; let i = $index) {
              <td [class]="getCellClassWithNote('actual', i, value) + (!isSummaryTable && canEditPlan && isCellEditableForDay(metricIndex, 'actual', i) ? ' editable-cell' : '')"
                  (dblclick)="!isSummaryTable && canEditPlan && isCellEditableForDay(metricIndex, 'actual', i) ? onCellDoubleClick(metricIndex, 'actual', i) : null"
                  (click)="$event.stopPropagation()">
                @if (!isEditing(metricIndex, 'actual', i)) {
                  {{ formatValue(value, i) }}
                }
                @if (!isSummaryTable && isEditing(metricIndex, 'actual', i)) {
                  <input type="number"
                         [ngModel]="getSingleCellEditingValue(metricIndex, i)"
                         (ngModelChange)="updateSingleCellEditingValue(metricIndex, i, $event)"
                         class="edit-input"
                         (keyup.enter)="saveSingleCellEditing()"
                         (keyup.escape)="cancelSingleCellEditing()"
                         (blur)="saveSingleCellEditing()"
                         (click)="$event.stopPropagation()">
                }
              </td>
            }
            <td class="total-cell actual-total">
              {{ getActualSum(metric) }}
            </td>
          </tr>
          
          <!-- Percentage row -->
          <tr class="percentage-row">
            <td class="metric-name percentage-label">%</td>
            @for (value of metric.percentageValues; track $index; let i = $index) {
              <td [class]="getCellClassWithNote('percentage', i, value)">
                {{ formatPercentage(value, i) }}
              </td>
            }
            <td class="total-cell percentage-total">
              {{ getPercentageAverage(metric) }}%
            </td>
          </tr>
        }
        
        <!-- Notes row - csak egyéni táblázatoknál -->
        @if (!isSummaryTable) {
          <tr class="notes-row">
            <td class="notes-empty-cell"></td>
            @for (day of dayNumbers; track $index; let i = $index) {
              <td [class]="'notes-cell ' + (isWeekend(i) ? 'weekend-cell' : 'weekday-cell')"
                  (mouseenter)="onDayHover(i)"
                  (mouseleave)="onDayLeave()">
            
              @if (shouldShowNoteIcon(i) && canEditPlan) {
                <mat-icon class="note-icon"
                          [matMenuTriggerFor]="dayNoteMenu.menu"
                          (click)="setSelectedDay(i, dayNoteMenuTrigger)"
                          (menuOpened)="dayNoteMenu.onMenuOpened()"
                          #dayNoteMenuTrigger="matMenuTrigger">
                  edit_note
                </mat-icon>
              }
              
              @if (shouldShowNoteChip(i)) {
                <mat-chip [class]="'note-chip ' + getNoteChipClass(i) + (canEditPlan ? ' clickable-chip' : '')"
                          [matMenuTriggerFor]="canEditPlan ? dayNoteMenu.menu : null"
                          (click)="canEditPlan ? setSelectedDay(i, dayNoteChipTrigger) : null"
                          (menuOpened)="dayNoteMenu.onMenuOpened()"
                          #dayNoteChipTrigger="matMenuTrigger">
                  <span>{{ getNoteText(i) }}</span>
                </mat-chip>
              }
              </td>
            }
            <td class="total-cell notes-total"></td>
          </tr>
        }

        <!-- Notes row - összesítő táblázathoz -->
        @if (isSummaryTable) {
          <tr class="notes-row">
            <td class="notes-empty-cell"></td>
            @for (day of dayNumbers; track $index; let i = $index) {
              <td [class]="'notes-cell ' + (isWeekend(i) ? 'weekend-cell' : 'weekday-cell')"
                  (mouseenter)="onDayHover(i)"
                  (mouseleave)="onDayLeave()">

                @if (shouldShowSummaryNoteIcon(i)) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="summaryDayNoteMenu.menu"
                            (click)="setSelectedDay(i, summaryNoteMenuTrigger)"
                            (menuOpened)="summaryDayNoteMenu.onMenuOpened()"
                            #summaryNoteMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }

                @if (shouldShowSummaryNoteChip(i)) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass(i) + (canEditPlan ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditPlan ? summaryDayNoteMenu.menu : null"
                            (click)="canEditPlan ? setSelectedDay(i, summaryNoteChipTrigger) : null"
                            (menuOpened)="summaryDayNoteMenu.onMenuOpened()"
                            #summaryNoteChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText(i) }}</span>
                  </mat-chip>
                }
              </td>
            }
            <td class="total-cell notes-total"></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Note menu - egyéni táblázathoz -->
@if (!isSummaryTable) {
  <app-small-input-menu
    inputType="notes"
    [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
    [showClearPlanCheckbox]="canEditPlan"
    [label]="'Jegyzet ' + (selectedDay + 1) + '. napra'"
    placeholder="Írj egy jegyzetet..."
    [inputValue]="notes[selectedDay] || ''"
    [showDeleteButton]="true"
    [menuTrigger]="currentMenuTrigger"
    (valueAdded)="onNoteAdded($event, selectedDay)"
    (clearPlanRequested)="onClearPlanForDay(selectedDay)"
    (cancelled)="onNoteCancelled()"
    (deleteClicked)="onNoteDeleted(selectedDay)"
    #dayNoteMenu>
  </app-small-input-menu>
}

<!-- Note menu - összesítő táblázathoz -->
@if (isSummaryTable) {
  <app-small-input-menu
    inputType="notes"
    [notePresets]="[]"
    [label]="'Összesítő note - ' + (selectedDay + 1) + '. napra'"
    placeholder="Írj egy összesítő note-ot..."
    [inputValue]="getSummaryNoteForDay(selectedDay)"
    [showDeleteButton]="true"
    [menuTrigger]="currentMenuTrigger"
    (valueAdded)="onSummaryNoteAdded($event, selectedDay)"
    (cancelled)="onNoteCancelled()"
    (deleteClicked)="onSummaryNoteDeleted(selectedDay)"
    #summaryDayNoteMenu>
  </app-small-input-menu>
}